import React, { useState } from "react";
import { useQuery } from "@apollo/client";
import { FETCH_TRANSACTIONS_QUERY } from "../graphql";
import { Header } from "../components/Header";
import { Transaction } from "../components/Transaction";
import { Container } from "@chakra-ui/react";
import Select from "react-select";
import { SimpleGrid, Box } from "@chakra-ui/react";
import moment from "moment";
import { Balance } from "../components/Balance";
import { IncomeExpenses } from "../components/IncomeExpenses";

export default function TransactionPage() {
  const { loading, error, data } = useQuery(FETCH_TRANSACTIONS_QUERY);

  const allMonths = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const currentDate = new Date();
  const currentMonth = currentDate.getMonth();
  const currentYear = currentDate.getFullYear();
  const [month, setMonth] = useState({ value: allMonths[currentMonth] });
  const [year, setYear] = useState({ value: currentYear.toString() });

  if (loading) return "Loading...";
  if (error) return `Error! ${error.message}`;
  const transactions = data.getTransactions;

  const endOfYear = new Date(`${currentYear}, 12, 31`);
  const yearlyTransactions = transactions.filter(
    (t) => new Date(t.createdAt) < endOfYear
  );
  const leonYear = yearlyTransactions.filter((t) => t.user === "Leon");
  const tramYear = yearlyTransactions.filter((t) => t.user === "Tram");

  const dateString = `${month.value}-${year.value}`;
  // console.log(moment(transactions[0].createdAt).format('MMMM-YYYY'));
  const filteredTransactinos = transactions.filter(
    (t) => moment(t.createdAt).format("MMMM-YYYY") === dateString
  );

  const leonMonthly = filteredTransactinos.filter((t) => t.user === "Leon");
  const tramMonthly = filteredTransactinos.filter((t) => t.user === "Tram");
  const transactionSort = [...filteredTransactinos];

  //TODO : ALL Button

  const monthOptions = [
    { value: "January", label: "January" },
    { value: "February", label: "February" },
    { value: "March", label: "March" },
    { value: "April", label: "April" },
    { value: "May", label: "May" },
    { value: "June", label: "June" },
    { value: "July", label: "July" },
    { value: "August", label: "August" },
    { value: "September", label: "September" },
    { value: "October", label: "October" },
    { value: "November", label: "November" },
    { value: "December", label: "December" },
  ];

  const yearOptions = [{ value: "2022", label: "2022" }];
  return (
    <>
      <SimpleGrid columns={3} spacingX="100px" spacingY="20px">
        <Box height="80px" w="100%">
          <SimpleGrid
            className="filter"
            columns={2}
            spacingX="10px"
            spacingY="20px"
          >
            <Box>
              <label>Month</label>
              <Select
                onChange={setMonth}
                options={monthOptions}
                defaultValue={monthOptions.filter(
                  (option) => option.label === month.value
                )}
              ></Select>
            </Box>
            <Box>
              <label>Year</label>
              <Select
                onChange={setYear}
                options={yearOptions}
                defaultValue={yearOptions.filter(
                  (option) => option.label === year.value
                )}
              ></Select>
            </Box>
          </SimpleGrid>
          <div className="total">
            <Balance transactions={leonMonthly} time="Month Total (Leon)" />
            <IncomeExpenses transactions={leonMonthly} />
            <Balance transactions={tramMonthly} time="Month Total (Tram)" />
            <IncomeExpenses transactions={tramMonthly} />
            <br/>
            <Balance transactions={leonYear} time="Year(Leon)" />
            <IncomeExpenses transactions={leonYear} />
            <Balance transactions={tramYear} time="Year(Tram)" />
            <IncomeExpenses transactions={tramYear} />
          </div>
          
        </Box>
        <Box height="80px" margin-left="10">
          <Container>
            <Header name="History" />
            <ul className="list">
              {transactionSort
                .slice(0)
                .reverse()
                .map((transaction) => (
                  <Transaction key={transaction.id} transaction={transaction} />
                ))}
            </ul>
          </Container>
        </Box>
        <Box height="80px" w="100%">
          <div className="totalYear">
            
            <Balance transactions={transactionSort} time="Month Total" />
            <IncomeExpenses transactions={transactionSort} />
            <Balance
              transactions={yearlyTransactions}
              time="Total Year"
              year={currentYear}
            />
            <IncomeExpenses transactions={yearlyTransactions} />
          </div>
        </Box>
      </SimpleGrid>
    </>
  );
}
